import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AuthServiceContext = createContext(null);
export function AuthServiceProvider({ value, children }) {
    return (_jsx(AuthServiceContext.Provider, { value: value, children: children }));
}
export function useAuthService() {
    const service = useContext(AuthServiceContext);
    if (!service) {
        throw new Error('useAuthService must be used within an <AuthServiceProvider>.');
    }
    return service;
}
//# sourceMappingURL=AuthServiceContext.js.map